import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import store from './store/store';
import {MetronicLayoutProvider, MetronicSplashScreenProvider, MetronicSubheaderProvider} from './shared/layout';
import {Provider} from 'react-redux';
import {ErrorBoundary} from "./ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
    <React.StrictMode>
        <MetronicLayoutProvider>
            <MetronicSubheaderProvider>
                <MetronicSplashScreenProvider>
                    <Provider store={store}>
                        <ErrorBoundary>
                            <App/>
                        </ErrorBoundary>
                    </Provider>
                </MetronicSplashScreenProvider>
            </MetronicSubheaderProvider>
        </MetronicLayoutProvider>
    </React.StrictMode>
);

reportWebVitals();
